import StyledSpeedButton from 'widget/components/SpeedButton/primitives/StyledSpeedButton';
import { useState } from 'react';

const playbackSpeeds = [1, 1.25, 1.5, 2];

type Props = {
  onClick: (speed: number) => void;
  sizeToHide: string;
};

const wrapIndex = (index: number, length: number) =>
  ((index % length) + length) % length;

function SpeedButton({ onClick, sizeToHide }: Props) {
  const [speed, changeSpeed] = useState(0);

  const handleClick = () => {
    const newSpeed = wrapIndex(speed + 1, playbackSpeeds.length);
    changeSpeed(newSpeed);
    onClick(playbackSpeeds[newSpeed]);
  };

  return (
    <StyledSpeedButton
      aria-label="Playback speed"
      data-test="speed-button"
      onClick={handleClick}
      sizeToHide={sizeToHide}
      type="button"
    >
      {`${playbackSpeeds[speed]}x`}
    </StyledSpeedButton>
  );
}

export default SpeedButton;
